export interface ModuleDef { title: string; sub: string }

export const MODS: Record<string, ModuleDef> = {
  docs: { title: 'Hỗ trợ chứng từ', sub: 'Invoice · Receipt · Debit/Credit Note · Thông báo CKTM · Phiếu thu cọc / hoàn cọc / phạt cọc' },
  cash: { title: 'Sổ quỹ tiền mặt', sub: 'Phiếu thu tiền mặt · Phiếu chi tiền mặt · Sổ quỹ' },
  labor: { title: 'Sổ lao động', sub: 'Người lao động · Chấm công · Bảng lương · Hợp đồng lao động' },
  tasks: { title: 'Quản lý công việc', sub: 'Giao việc · Theo dõi tiến độ · Hạn hoàn thành · Trao đổi trong đội' },
  cal: { title: 'Lịch', sub: 'Lịch họp, công tác, hạn công việc, hợp đồng hết hạn – dùng chung cho cả đội' },
  vb: { title: 'Quản lý văn bản', sub: 'Thông báo · Quyết định · Công văn đi · Công văn đến · Tờ trình · Biên bản · Quy chế' },
  org: { title: 'Thông tin đơn vị', sub: 'Thông tin công ty, tài khoản ngân hàng, người ký, cơ cấu tổ chức, đánh số chứng từ – dùng chung cho mọi phân hệ' },
  users: { title: 'Quản lý người dùng', sub: 'Tạo tài khoản, kích hoạt, ngừng kích hoạt, đặt lại mật khẩu' },
};

/** Thứ tự ưu tiên khi chọn phân hệ mở đầu tiên. */
export const MOD_ORDER = ['docs', 'cash', 'labor', 'vb', 'tasks', 'org', 'users'];

export interface NavGroup { label: string; mods: string[] }
export const NAV_GROUPS: NavGroup[] = [
  { label: 'Hành chính - Nhân sự', mods: ['labor', 'vb'] },
  { label: 'Kế toán', mods: ['docs', 'cash'] },
  { label: 'Hệ thống', mods: ['org', 'users'] },
];
